import { render, staticRenderFns } from "./ActionFavorites.vue?vue&type=template&id=7d6721d0&scoped=true&"
import script from "./ActionFavorites.vue?vue&type=script&lang=js&"
export * from "./ActionFavorites.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ActionFavorites.vue?vue&type=style&index=0&id=7d6721d0&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7d6721d0",
  null
  ,true
)

export default component.exports